import React from 'react';
import AiSuggestions from 'Components/AiSuggestions';

/**
 * The company card's slice of the agent's pending suggestions — everything but
 * the scoping lives in AiSuggestions, which the task list renders user-scoped.
 */
const DashboardAiSuggestions = ({ clientId }: { clientId: number }) => (
	<AiSuggestions scope={{ type: 'client', clientId }} title="aiSuggestions.title" />
);

export default DashboardAiSuggestions;
